import SolicitationService from '@/services/solicitation.service'
import Utils from '@/utils'
import _ from 'lodash'

const state = {
    types: [
        {
            id: '',
            description: 'Todos'
        }
    ],
    reasons: [
        {
            id: '',
            description: 'Todos',
            external_id: null,
            status: null
        }
    ],
    page: {
        results: [],
        count: 0,
        next: null,
        previous: null
    },
    filterLoading: false
}

const getters = {}

const actions = {
    readTypes: async ({ commit }) => {
        try {
            let types = await SolicitationService.readTypes()
            commit('readTypesSuccess', types)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    readReasons: async ({ commit }) => {
        try {
            let reasons = await SolicitationService.readReasons()
            commit('readReasonsSuccess', reasons)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    readSolicitations: async ({ commit }, args) => {
        if (!args) args = {}
        if (!args.page) args.page = 1
        if (state.page.index == args.page) return true
        try {
            commit('reading')
            let page = await SolicitationService.readSolicitations(args)
            commit('readSolicitationsSuccess', page.data, args.page)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    filter: async ({ }, args) => {
        try {
            let solicitations = await SolicitationService.readSolicitations(args)
            return solicitations
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    updateSolicitation: async ({ commit }, args) => {
        try {
            commit('reading')
            const response = await SolicitationService.updateSolicitation(args)
            commit('updateSolicitationSuccess', response)
            return null
        } catch (e) {
            commit('readSolicitationsFail')
            if (e && e.response) throw e.response.status
            else throw 500
        }
    },

    create: async ({ }, args) => {
        try {
            await SolicitationService.create(args)
            return { message: 'Pedido enviado com sucesso!', status: 201 }
        } catch (e) {
            const status = e && e.response ? e.response.status : 500
            return { message: 'Falha ao criar o pedido', status }
        }
    }
}

const mutations = {
    reading(state) {
        state.filterLoading = true
    },

    readTypesSuccess(state, types) {
        state.types = [
            {
                id: '',
                description: 'Todos'
            },
            ...types
        ]
    },

    readReasonsSuccess(state, reasons) {
        state.reasons = [
            {
                id: '',
                description: 'Todos',
                external_id: null,
                status: null
            },
            ...reasons
        ]
    },

    readSolicitationsSuccess(state, page, page_index) {
        Utils.datetimeConverter(page.results)
        state.page = page
        state.page.index = page_index
        state.filterLoading = false
    },

    readSolicitationsFail(state) {
        state.filterLoading = false
    },

    updateSolicitationSuccess(state, solicitation, page) {
        const index = state.page.results.findIndex(result => result.id === solicitation.data.id)
        const solicitationConverted = Utils.datetimeConverter([solicitation.data])
        state.page.results.splice(index, 1, solicitationConverted[0])
        state.filterLoading = false
    }
}

const solicitations = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default solicitations
export { solicitations }
